export const locale = {
    lang: 'pl',
    data: {
        'Created at': 'Data dodania',
        'Description': 'Opis',
        'Additional info': 'Dodatkowe informacje',
        'Customers': 'Klienci',
        'Cards': 'Karty',
        'History': 'Historia',
        'serviceName': 'Usługa',
        'All services': 'Wszystkie usługi',
        'balance': 'Punkty',
        'expirationDate': 'Data wygaśnięcia',
        'addedAt': 'Data dodania',
        'New item was added to cart.': 'Nowa pozycja została dodana do karty.',
        'The card was created': 'Karta została utworzona.',
        'Entrance was accepted.': 'Wejście zostało zaakceptowane.',
        'acceptedBy': 'Zaakceptowane przez',
        'cardNumber': 'Numer karty',
        'Card is suspended.': 'Karta jest zawieszona.',
        'deviceId': 'Identyfikator urządzenia',
        'errorMessage': 'Treść błędu',
        'Voucher has been added to card.': 'Karnet został dodany do karty',
        'quantity': 'Ilość',
        'Voucher validity date was changed.': 'Data ważności karnetu została zmieniona.',
        'changedBy': 'Zmienione przez',
        'voucherUuid': 'UUID karnetu',
        'activeFromDate': 'Aktywny od',
        'Card has been suspended.': 'Karta została zawieszona.',
        'suspendedBy': 'Zaiweszony przez',
        'days': 'Ilość dni',
        'suspendedAt': 'Zawieszono dnia',
        'card_number': 'Numer karty',
        'creation_date': 'Data utworzenia',
        'Start exercise on %deviceId%': 'Rozpoczęto ćwiczenie na %deviceId%',
        'resourceName': 'Nazwa urządzenia',
        'startDate': 'Data rozpoczęcia',
        'New item was added to card.': 'Nowa usługa została dodana do karty.',
        'exitDate': 'Data wyjścia',
        'The card was drawn on the exit device %deviceId%': 'Karta została odbita na urządzeniu wyjściowym %deviceId%',
        'The card was drawn on the start device %deviceId%': 'Karta została odbita na urządzeniu wejściowym %deviceId%',
        'Card has been unsuspended.': 'Zawieszenie karty zostało cofnięte.',
        'unsuspendedAt': 'Cofnięto zawieszenie',
        'unsuspendedBy': 'Zawieszenie cofnięte przez',
        'active': 'Aktywny',
        'true': 'Tak',
        'false': 'Nie',
        'Name': "Nazwa",
        'Active from': "Od",
        'Active to': 'Do',
        'Active vouchers': 'Aktywne karnety',
        'Online Carts': 'Koszyki online',
        'Resources online': 'Urządzenia online',
        'Users online': 'Użytkownicy online',
        'New': 'Nowy klient',
        'Show error logs': 'Pokaż logi błędów',
        'Hide error logs': 'Ukryj logi błędów',
        'Voucher': 'Karnet',
        'Items': 'Pozycje',
        'Open day voucher': 'Karnet na pierwszy dzień',
        'No': 'Nie',
        'Yes': 'Tak',
    }
};
